import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { MessageService } from "../../services/message.service";
import { GenericDialog } from "../generic-dialog/GenericDialog.component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
export function ConfirmDialog() {
    const [isVisible, setIsVisible] = useState(false);
    const [question, setQuestion] = useState("");
    const [yesText, setYesText] = useState("");
    const [noText, setNoText] = useState("");
    const confirmFn = useRef(() => { });
    const rejectFn = useRef(() => { });
    const { t } = useTranslation();
    const showConfirmation = (question, yesText, noText, onConfirm, onReject) => {
        setQuestion(question);
        setYesText(yesText);
        setNoText(noText);
        confirmFn.current = onConfirm;
        rejectFn.current = onReject;
        setIsVisible(true);
    };
    useEffect(() => {
        MessageService.registerGlobalConfirmationFn(showConfirmation);
    }, []);
    const confirm = () => {
        setIsVisible(false);
        confirmFn.current();
    };
    const reject = () => {
        setIsVisible(false);
        rejectFn.current();
    };
    return (React.createElement(React.Fragment, null, isVisible && (React.createElement(GenericDialog, { title: t("common:confirm-dialog-button-confirm", "Confirm"), confirmText: yesText, cancelText: noText, onCancel: reject, onConfirm: confirm, width: "narrow" },
        React.createElement("div", { className: "confirm-dialog-content" },
            React.createElement(FontAwesomeIcon, { icon: ["fas", "question-circle"], size: "2x", className: "info-color" }),
            React.createElement("span", { className: "confirm-dialog-question" }, question))))));
}
